import {useState, type ReactNode, useRef, useEffect} from 'react'
import {motion} from 'framer-motion'
import Magnifier from '@local/assets/svgs/magnifier.svg'

export interface SearchBarProps {
	children: ReactNode
	className: string
}

export const SearchBar = ({query, handleOnSearch}) => {
	const [isOpen, setIsOpen] = useState(false)
	const componentRef = useRef(null)

	const handleClickOutside = (event) => {
		if (componentRef.current && !componentRef.current.contains(event.target)) {
			setIsOpen(false)
		}
	}

	useEffect(() => {
		document.addEventListener('click', handleClickOutside)
		return () => {
			document.removeEventListener('click', handleClickOutside)
		}
	}, [])
	return (
		<form action='' ref={componentRef} className='flex h-40 my-auto border shadow-sm lg:flex-row md-max:mt-20 border-black/5'>
			<motion.input initial={{width: 0}} animate={{width: isOpen ? 250 : 0}} placeholder='Search...' className='ml-5 outline-none focus:outline-none' type='text' value={query} onChange={handleOnSearch} />
			<motion.div className='w-full' animate={{opacity: isOpen ? 0 : 1}} onClick={() => { setIsOpen(!isOpen) }}>
				<Magnifier className='lg:w-36 h-36' />
			</motion.div>
		</form>
	)
}
